import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api, apiErr } from "../lib/api";
import { fmt } from "../lib/format";
import { Button } from "../components/ui/button";
import { toast } from "sonner";
import { Loader2, Lock, ShieldCheck } from "lucide-react";

export default function PayPage() {
  const { token } = useParams();
  const nav = useNavigate();
  const [order, setOrder] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get(`/store/order/${token}`).then((r) => setOrder(r.data)).catch((e) => toast.error(apiErr(e)));
  }, [token]);

  const pay = async (outcome) => {
    setBusy(true);
    try {
      const { data } = await api.post(`/store/order/${token}/mock-callback`, { outcome });
      if (outcome === "success") toast.success("Pagamento riuscito");
      else toast.error(outcome === "cancel" ? "Pagamento annullato" : "Pagamento fallito");
      nav(data.redirect);
    } catch (e) { toast.error(apiErr(e)); }
    finally { setBusy(false); }
  };

  if (!order) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="animate-spin" /></div>;

  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center p-4">
      <div className="w-full max-w-sm bg-white rounded-2xl shadow-xl overflow-hidden">
        <div className="bg-[#0a2540] text-white p-5">
          <div className="flex items-center justify-between">
            <span className="font-bold text-lg">myPOS</span>
            <span className="text-xs bg-amber-400 text-black font-bold px-2 py-0.5 rounded">SANDBOX / MOCK</span>
          </div>
          <p className="text-xs text-white/70 mt-1 flex items-center gap-1"><Lock size={12} /> Pagina di pagamento sicura simulata</p>
        </div>
        <div className="p-6">
          <p className="text-sm text-slate-500">Ordine #{order.short_code}</p>
          <p className="font-head text-3xl font-extrabold mt-1">{fmt.eur(order.total)}</p>
          <div className="mt-4 text-xs bg-amber-50 border border-amber-200 rounded-lg p-3 text-amber-800">
            Provider di sviluppo. In produzione i dati carta vengono inseriti solo sulla pagina myPOS reale, mai su Pickfood.
          </div>
          <div className="mt-6 space-y-2">
            <Button onClick={() => pay("success")} disabled={busy} data-testid="pay-success" className="w-full h-12 bg-[#00a651] hover:bg-[#008c44] rounded-xl font-semibold">
              {busy ? <Loader2 className="animate-spin" /> : <><ShieldCheck size={18} className="mr-1" /> Paga {fmt.eur(order.total)}</>}
            </Button>
            <Button onClick={() => pay("fail")} disabled={busy} variant="outline" className="w-full h-11 rounded-xl" data-testid="pay-fail">Simula pagamento fallito</Button>
            <Button onClick={() => pay("cancel")} disabled={busy} variant="ghost" className="w-full h-11 rounded-xl text-slate-500" data-testid="pay-cancel">Annulla</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
